import React, { useEffect, useState } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import { Alert, Button, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { UserAgentApplication } from "msal";

import MasterPageAuth from "../../layouts/master-page-auth";
import logoLight from "../../assets/images/logo-light.png";
import IconBtnMS from '../../assets/images/icons/btn-icon-ms.png';
import configData from "../../config.json";

const Login = () => {
    const history = useHistory();
    const [error, setError] = useState("");
    const [passwordShow, setPasswordShow] = useState(false);
    const [msAuthState, setMsAuthState] = useState(null);
    
    sessionStorage.clear();

    useEffect(() => {
        const msConfig = {
            auth: {
                clientId: 'b62024cf-cff5-492e-972d-153c0828cc42',
                redirectUri: configData.APP_REDIRECT_LOGIN,
            },
        };
        let msAuth = new UserAgentApplication(msConfig);
        setMsAuthState(msAuth);
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            let url = configData.API_URL_AUTHEN + "login";
            let data = {
                user_name: values.email,
                password: values.password,
                app_key: configData.APP_KEY,
                app_secret: configData.APP_SECRET
            }
            axios.post(url, data, { responseType: "json" })
            .then(resp => {
                let respData = resp.data;
                if(respData.is_sucess === true){
                    sessionStorage.setItem("token", respData.data.token);
                    sessionStorage.setItem("uid", respData.data.id_emp);
                    sessionStorage.setItem("name", respData.data.name + " " + respData.data.surname);
                    history.push("/");
                }else{
                    setError("Username or Password Invalid.");
                }
            })
            .catch(error => {
                setError("Username or Password Invalid.");
                console.log(error);
            });
        }
    });

    const OnClickLoginOffice365 = () => {
        msAuthState.loginPopup({
            scopes: ['User.Read'],
        }).then((response) => {
            if (response) {
                const respO365 = response.account;
                // console.log("Office365", respO365);
                let url = configData.API_URL_AUTHEN + "login-o365";
                let data = {
                    user_name: respO365.userName,
                    app_key: configData.APP_KEY,
                    app_secret: configData.APP_SECRET
                }
                axios.post(url, data, { responseType: "json" })
                .then(resp => {
                    let respData = resp.data;
                    console.log(respData);
                    if(respData.is_sucess === true){
                        sessionStorage.setItem("token", respData.data.token);
                        sessionStorage.setItem("uid", respData.data.id_emp);
                        sessionStorage.setItem("name", respData.data.name + " " + respData.data.surname);
                        history.push("/");
                    }else{
                        setError("Username or Password Invalid.");
                    }
                })
                .catch(error => {
                    setError("Username or Password Invalid.");
                    console.log(error);
                });
            }
        }).catch(error => {
            // console.error(error);
        });
    };

    return(
        <React.Fragment>
            <MasterPageAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" height="50" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">HRIS Admin</h5>
                                            {/* <p className="text-muted">BTS Group</p> */}
                                        </div>
                                        { (error !== null && error !== '') ? (<Alert color="danger"> {error} </Alert>) : null}
                                        <div className="p-2 mt-2">
                                            <Form action="#"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}  
                                            >
                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button id="password-addon" type="button" onClick={() => setPasswordShow(!passwordShow)}
                                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" 
                                                        >
                                                            <i className="ri-eye-fill align-middle"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="mt-4">
                                                    <Button color="success" className="btn btn-success w-100" type="submit">Sign In</Button>
                                                    <Button className="login-btn" type="button" onClick={OnClickLoginOffice365}>
                                                        <img src={IconBtnMS} alt="" />
                                                        <Label>Login with Microsoft 365</Label>
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </MasterPageAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);